const Payments = () => {
  return (
    <div className="max-w-6xl mx-auto">
      <h1 className="text-4xl font-bold text-gray-800 mb-4">Payments</h1>
      <p className="text-gray-600">Track and manage payments here...</p>
    </div>
  );
};

export default Payments;
